export {
  searchClient,
  customSearchClient,
  indexName,
  productServicesIndexName,
  retailMediaIndexName,
} from './search-client';
export { insightsConfig } from './insights-config';
export { normalizeProduct } from './normalize-product';
export type { ProductProps } from './normalize-product';
